import React from 'react';
import { Modal, Input, Row, message, Col, Checkbox } from 'antd';
import { _postAddLeafPage } from '../../../services/index';

const { TextArea } = Input;

class AddLeafPageModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      newName: '',
      newDesc: '',
      imageURL: '',
    }
  }

  render() {

    return (
      <div>
        <Modal
          title="Add New Leaf Page"
          visible={this.props.modalVisible}
          onOk={this.onOkClick}
          onCancel={this.onCancel}
        >
          <Row>
            <img 
              src={this.state.imageURL}
              alt="Leaf Page"
              width={this.state.industry?294: 200}
            />
          </Row>
          <Row>
            <Input 
              placeholder="Image URL"
              size="large"
              onChange={(e) => this.onInputChange(e, 'imageURL')}
              value={this.state.imageURL}
            />
          </Row>
          <Row>
            <Checkbox
              onChange={(e) => this.setState({
                industry: e.target.checked
              })}
            >Industry</Checkbox>
            {this.state.industry &&
            <div>
              Warning: Please ensure that the image dimensions are correct!
            </div>
            }
          </Row>
          <Row type="flex">
            <Input
              placeholder="Enter Desktop Name"
              size="large"
              onChange={(e) => this.onInputChange(e, 'newName')}
              value={this.state.newName}
              autoFocus
            />
          </Row>

          <Row type="flex">
            <Input
              placeholder="Enter Mobile Name"
              size="large"
              onChange={(e) => this.onInputChange(e, 'mobileName')}
              value={this.state.mobileName}
              autoFocus
            />
          </Row>

          <Row type='flex' style={{ marginTop: 15 }}>
            <TextArea
              onChange={this.onDescChange}
              placeholder="Description"
              value={this.state.newDesc}
              rows={4}
            />
          </Row>
          <Row type="flex" style={{ marginTop: 15 }}>
            <span>Characters: {this.state.newDesc.length}/160</span>
          </Row>
        </Modal>
      </div>
    );
  }

  onInputChange (e, input) {
    e.persist();

    this.setState({
      [input]: e.target.value
    })
  }

  onDescChange = (e) => {
    e.persist();

    if (e.target.value.length >= 161) {
      message.error('Only 160 characters are allowed!', 3);
    } else {
      this.setState({
        newDesc: e.target.value
      })
    }
  }

  onOkClick = () => {

    let { newName, newDesc, imageURL, mobileName, industry } = this.state;

    _postAddLeafPage( newName, newDesc, imageURL, this.props.position, mobileName, industry )
      .then(res => {
        console.log(res.data);
        message.success(`"${res.data.added.leafName}" has been created!`, 3);
        this.props.updateData();
        this.props.onModalVisible();
        this.setState({
          newName: "",
          newDesc: "",
          imageURL: "",
        })
      })
      .catch(err => console.log(err));
  }

  onCancel = () => {
    this.setState({
      newName: "",
      newDesc: ""
    })

    this.props.onModalVisible()
  }

  countCharacters = () => {
    return this.state.newDesc.length;
  }

}

export default AddLeafPageModal;


// WEBPACK FOOTER //
// ./src/components/leaf-page/modals/add-leaf-page.js